import { Component } from '@angular/core';

@Component({
  selector: 'app-date-table',
  templateUrl: './date-table.component.html',
  styleUrls: ['./date-table.component.scss']
})
export class DateTableComponent {
  dayOfWeek: string; // This should be set to the current day of the week
  days = [
    { name: 'Monday', hours: '8:00 am - 8:00 pm' },
    { name: 'Tuesday', hours: '8:00 am - 8:00 pm' },
    { name: 'Wednesday', hours: '8:00 am - 8:00 pm' },
    { name: 'Thursday', hours: '8:00 am - 8:00 pm' },
    { name: 'Friday', hours: '8:00 am - 8:00 pm' },
    { name: 'Saturday', hours: 'Closed' },
    { name: 'Sunday', hours: '8:00 am - 8:00 pm' },
  ];

  constructor() {
    // Initialize dayOfWeek with the current day, e.g., using Date() or a service
    this.dayOfWeek = this.getCurrentDayOfWeek();
  }

  getCurrentDayOfWeek(): string {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const date = new Date();
    return days[date.getDay()];
  }
}
